import * as geometryEngine from 'esri/geometry/geometryEngine'
import Polyline = require("esri/geometry/Polyline");
import Graphic = require("esri/Graphic");
import GraphicsLayer = require("esri/layers/GraphicsLayer");
import Draw = require("esri/views/draw/Draw");
import DrawAction = require("esri/views/draw/DrawAction");
import MapView = require("esri/views/MapView");
import * as baseGroup from "../../data/Layers/baseGroup";
import ToolBar from "./../Toolbar";
import { finalPolygon } from "./SelectionResultTable";
import ToolButton from "./toolButton";
import Query = require('esri/rest/support/Query');
import Point = require('esri/geometry/Point');
import Geometry = require("esri/geometry/Geometry");
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import {clearGraphicType, highlightColor} from '../App/setupView';
import { PictureMarkerSymbol } from 'esri/symbols';
import webMercatorUtils = require("esri/geometry/support/webMercatorUtils");
import FeatureSet = require('esri/rest/support/FeatureSet');
import { Polygon } from 'esri/geometry';

export default class MeasureRouteDistanceTool extends ToolButton {

  snapPoints : Point[];
  snapIndex : number[];  // Index of point in curRoute
  routeGeometry : Geometry;
  inv: string;
  drawLayer: GraphicsLayer;
  private toSymbol = new PictureMarkerSymbol({
    "angle": -45,
    "xoffset": -9,
    "yoffset": 9,
    "url": "https://static.arcgis.com/images/Symbols/Shapes/RedPin1LargeB.png",
    "width": 24,
    "height": 24
    });

  private fromSymbol = new PictureMarkerSymbol({
    "angle": -45,
    "xoffset": -9,
    "yoffset": 9,
    "url": "https://static.arcgis.com/images/Symbols/Shapes/GreenPin1LargeB.png",
    "width": 24,
    "height": 24
  });

  private draw: Draw;

  // create a new graphic representing the polyline, add it to the view
  private distanceGraphic: Graphic;
  private action: DrawAction;
  private curRoute : Polyline | null;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
    this.draw = new Draw({ view: viewIn });
  }

  deactivateTool() {
    // console.log("measureRouteDistanceTool deactivateTool")
    this.clearMeasure();
    if (this.view.popup.content.toString().indexOf("Inventory") === -1) { // if no results, hide popup
      this.view.popup.visible = false;
    }
    document.body.style.cursor = "default";
  }

  clearMeasure() {
    if (this.draw && this.draw.view && this.draw.activeAction) {
      this.draw.reset();
    }
    this.snapPoints = [];
    this.snapIndex = [];
    this.curRoute = null;
    document.body.style.cursor = "crosshair";
  }

  createAction() {
    this.clearMeasure();
    this.action = this.draw.create("polyline", {mode:"click"});
    this.action.on("vertex-add", (event) => this.drawpolyline(event));
    this.action.on("cursor-update", (event) => this.drawpolyline(event));
    this.action.on("vertex-remove", (event) => this.drawpolyline(event));
    this.action.on("redo", (event) => this.drawpolyline(event));
    this.action.on("undo", (event) => this.drawpolyline(event));
    this.action.on("draw-complete", (event) => {
      // console.log("measureRouteDistanceTool draw-complete");
      this.drawpolyline(event);
      this.toolbar.setPanAsActiveTool();
      // this.createAction();
    });
    this.view.popup.visible = true;
  }

  activateTool(event: any) {
    // console.log("measureRouteDistanceTool start")
    this.iconDiv = event.currentTarget;
    this.drawLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;

    if (this.toolbar) {
      this.toolbar.setActiveTool(this as ToolButton);
    }
    try {
      if (this.view) {
        this.view.focus();
        this.view.popup.open({
          title: "Measure Route Results",
          content: "Click on map to select road to measure route"
        });
        this.createAction();

      }
    } catch (error) {
      console.error("Error: in measureRouteDistanceTool " + +error.message);
    }
  }

  private findNearestRoad(mercPoints:Point[], mapPoint: Point) {
    let closestDist = 999999;
    let closestIndex = 0;
    mercPoints.forEach((value, index) => {
      const dist = geometryEngine.distance(mapPoint, value, "meters");
      //console.log("dist = " + dist + "  ")
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = index;
      }
    });
    return {closestDist, closestIndex}
  }

  private findRoute(mapClick:Point) {
    // console.log("findRoute " + mapClick );
    document.body.style.cursor = "wait";
    clearGraphicType(this.view, "selected");
    clearGraphicType(this.view, "measureRouteDistance");
    const query = new Query({
      // objectIds: [189280],
      geometry: mapClick,
      spatialRelationship: "intersects",
      distance: 50,
      units: "meters",
      outFields: ["*"],
      outSpatialReference: { wkid: 4326 },
      returnGeometry: true
    });


    let againstFeatureSet: __esri.FeatureSet|null = null;
    let withFeatureSet: __esri.FeatureSet|null = null;

    let closestAgainstRoute = -1;
    let againstDist = 99999;

    let closestWithRoute = -1;
    let withDist = 99999;
    
    async function ConvertToMercator(featSet:FeatureSet){
      const mercPoints:Point[] = [];
      featSet.features.forEach(async (value, index) => {
        const polygonRing = [
            [value.geometry.extent.xmin, value.geometry.extent.ymin],
            [value.geometry.extent.xmin, value.geometry.extent.ymax],
            [value.geometry.extent.xmax, value.geometry.extent.ymax],
            [value.geometry.extent.xmax, value.geometry.extent.ymin],
            [value.geometry.extent.xmin, value.geometry.extent.ymin] // Close the ring
        ];
        
        // Create the Polygon object
        const extentPolygon = new Polygon({
            rings: [polygonRing],
            spatialReference: value.geometry.spatialReference
        });
        let centerPnt = extentPolygon.centroid;
        
        let geoPoint  = new Point({
          x: centerPnt.x,
          y: centerPnt.y,
          spatialReference: centerPnt.spatialReference
        });

        let merPoint = await webMercatorUtils.geographicToWebMercator(geoPoint) as Point;
        mercPoints.push(merPoint);
      });
      return mercPoints;
    };

    // Query Against Layer
    baseGroup.StateKRLayerAgainst
      .queryFeatures(query)
      .then(async featureSetAgainst => {
        // console.log("Query Against Layer length ", featureSetAgainst.features.length);
        
        if (featureSetAgainst.features.length > 0) {
          const mercPoints:Point[] = await ConvertToMercator(featureSetAgainst);
          //console.log("Done ConvertToMercator1")
          const {closestDist, closestIndex} = await this.findNearestRoad(mercPoints, mapClick);
          //console.log("Done findNearestRoad1")
          closestAgainstRoute = closestIndex;
          againstDist = closestDist;
          againstFeatureSet = featureSetAgainst;
        }
        //console.log("Done featureSetAgainst query")
        
      // Query With Layer
      baseGroup.StateKRLayerWith
        .queryFeatures(query)
        .then(async featureSetWith => {
          
          if (featureSetWith.features.length > 0) {
            const mercPoints:Point[] = await ConvertToMercator(featureSetWith);
            //console.log("Done ConvertToMercator2")
            const {closestDist, closestIndex} = await this.findNearestRoad(mercPoints, mapClick);
            //console.log("closestDist " + closestDist + " closestIndex " + closestIndex)
            closestWithRoute = closestIndex;
            withDist = closestDist;
            withFeatureSet = featureSetWith;
          }
          if (againstFeatureSet === null && withFeatureSet === null) {
            this.createAction();
            this.view.popup.set("content", "<b><p style='font-size:16px; color:red'>No road found. Try again.</p></b>");
          } else {
            
            let features;
            let layer;
            let closestRoute = -1;
            if (againstFeatureSet !== null && againstDist < withDist) {
              features = (againstFeatureSet as __esri.FeatureSet).features;
              layer = baseGroup.StateKRLayerAgainst;
              closestRoute = closestAgainstRoute;
              //console.log("Against Layer Closest");
            }
            //console.log("withFeatureSet displayFieldName " + withFeatureSet?.displayFieldName);
            if (withFeatureSet !== null && againstDist >= withDist) {
              features = (withFeatureSet as __esri.FeatureSet).features;
              layer = baseGroup.StateKRLayerWith;
              closestRoute = closestWithRoute;
              //console.log("With Layer Closest");
            }
            if (features !== undefined && layer !== undefined) {
              this.inv = features[closestRoute].attributes.INVENTORY;
              // console.log("findRoute route =  " +  this.inv);
    
              const queryInv = new Query({
                where: "INVENTORY = '" + this.inv + "'",
                outFields: ["*"],
                outSpatialReference: { wkid: 4326 },
                returnGeometry: true
              });
              layer
              .queryFeatures(queryInv)
              .then(featureSet2 => {
                 //console.log("Query Found Layer length ", featureSet2.features.length);

                if (featureSet2.features.length > 0) {
                   //console.log("Found route " + this.inv);
    
                  const allGeometry:Geometry[] = [];
                  featureSet2.features.forEach(feature => {
                    allGeometry.push(feature.geometry);
                  });
    
                  this.curRoute = geometryEngine.union(allGeometry) as Polyline; // featureSet2.features;
    
                  const roadGraphic = new Graphic({
                    geometry: this.curRoute,
                    attributes: { type: "selected" },
                    symbol: new SimpleLineSymbol({
                      color: highlightColor,
                      width: 5 // points
                    })
                  });
                  this.drawLayer.add(roadGraphic);
                  this.view.popup.set("content", "Click on route to select Start point");
                  document.body.style.cursor = "crosshair";
                } else {
                  this.createAction();
                  this.view.popup.set("content", "<b><p style='font-size:16px; color:red'>No road found. Try again.</p></b>");
                }
              })
              .catch(reason => {
                this.createAction();
                console.error("Error in snapToRoads, query Inventory ", reason);
              });
            } else {
              this.createAction();
              console.error("Found Layer and Features Null, this shouldn't happen")
            }
          }

        })
        .catch(reason => {
          console.error("Error in snapToRoads ", reason);
          this.createAction();
        });
  

      })
    .catch(reason => {
      console.error("Error in snapToRoads ", reason);
      this.createAction();
    });


  }


  private async addPoint(mapClick:Point, vertexIndex:number, eventType:string) {
    //console.log("In AddPoint:  Event " + eventType + " addPoint " + mapClick.x + " " + mapClick.y + " vertexInd = " + vertexIndex + " snapPoints.lenght " + this.snapPoints.length);

    if (this.curRoute) {
      if (this.snapPoints.length >= 2) {   // trim snap points to only keep two points.
        this.snapPoints.splice(1);
        this.snapIndex.splice(1);
      }
      //If the Current Route isn't WebMercator then convert it TRG 5/2025
      let merPolyline = this.curRoute;
      //console.log("merPolyline" + merPolyline.spatialReference.isWebMercator + " mapclick=" + mapClick.spatialReference.isWebMercator);
      if(this.curRoute.spatialReference.isWebMercator == false)
      {
        merPolyline = await webMercatorUtils.geographicToWebMercator(this.curRoute) as Polyline;
        //console.log("merPolyline" + merPolyline.spatialReference.isWebMercator + " mapclick=" + mapClick.spatialReference.isWebMercator);
      } 
      const near = geometryEngine.nearestCoordinate(merPolyline, mapClick);
      this.snapPoints.push(near.coordinate);
      this.snapIndex.push(near.vertexIndex);
      //console.log("near.coordinate:" + near.coordinate.x + " " + near.coordinate.y); 
      


      if (this.snapPoints.length === 1) { // draw start symbol}
        const fromGraphic = new Graphic({
          geometry: near.coordinate,
          attributes: { type: "measureRouteDistance" },
          symbol: this.fromSymbol
        });
        this.drawLayer.add(fromGraphic);
      } else if (this.snapPoints.length === 2 && eventType === "draw-complete") { // draw stop symbol
        const toGraphic = new Graphic({
          geometry: near.coordinate,
          attributes: { type: "measureRouteDistance" },
          symbol: this.toSymbol
        });
        this.drawLayer.add(toGraphic);
      }

      await this.showRoute(merPolyline);
    }
  }

  private showRoute(mercatorPolyine:Polyline) {
    if (this.curRoute) {
      if (this.distanceGraphic) {
          this.drawLayer.remove(this.distanceGraphic);
      }

      const allPoints:Point[] = [];
      const reverse = this.snapIndex[0] > this.snapIndex[this.snapIndex.length-1];
      // console.log ("curRoute.paths[0].length ", this.curRoute.paths[0].length, " reverse = ", reverse);

      for (let i=0; i<this.snapPoints.length; i++) {
        allPoints.push(this.snapPoints[i]);
        //console.log("In Show Route: added snapPoint " + i + " x= " + this.snapPoints[i].x + " y= " + this.snapPoints[i].y);
        if (i<this.snapPoints.length-1) {  // if not last point, add intermediate route points.
          // console.log("snapPoint " + i + " snapIndex[i] " + this.snapIndex[i] + " snapIndex[i+1] " + this.snapIndex[i+1]);
          if (reverse) {
            for (let j=this.snapIndex[i]; j > this.snapIndex[i+1]; j--) {
              if (j < mercatorPolyine.paths[0].length) { // make sure in range
                //console.log("1 curRoute[0]["+j+"]  ", this.curRoute.paths[0][j]);
                allPoints.push(new Point({x:mercatorPolyine.paths[0][j][0], y:mercatorPolyine.paths[0][j][1]}));
              }
            }
          } else {
            for (let j=this.snapIndex[i]+1; j <= this.snapIndex[i+1]; j++) {
              if (j < mercatorPolyine.paths[0].length) { // make sure in range
                //console.log("2 curRoute[0]["+j+"]  ", this.curRoute.paths[0][j]);
                allPoints.push(new Point({x:mercatorPolyine.paths[0][j][0], y:mercatorPolyine.paths[0][j][1]}));
              }
            }
          }
        }
      }

      const polyline = new Polyline({spatialReference: this.view.spatialReference});
      polyline.addPath(allPoints);

      this.distanceGraphic = new Graphic({
        attributes: { type: "measureRouteDistance" },
        symbol: finalPolygon,
        geometry: polyline,
        popupTemplate: {
          title: "Measure Route Results",
          content: ""
        }
      });

      this.drawLayer.add(this.distanceGraphic);
      // calculate the area of the polyline
      let length = geometryEngine.geodesicLength(polyline, "miles");
      if (length < 0) {
        // simplify the polyline if needed and calculate the area again
        const simplifiedPolyline: Polyline = new Polyline(geometryEngine.simplify(polyline));
        if (simplifiedPolyline) {
          length = geometryEngine.geodesicLength(simplifiedPolyline, "miles");
        }
      }
      // start displaying the area of the polyline
      const feet = length * 5280;

      const content =
        "<p style='font-size:16px'>" +
        "Inventory " + this.inv + "</p>" +
        "<p style='font-size:20px'>" +
        "Route length: <b>" +
        length.toFixed(3) +
        "</b> miles<br/>" +
        "Route length: <b>" +
        feet.toFixed(0) +
        "</b> feet" +
        "</p>";
      this.view.popup.set("content", content);
      this.view.popup.visible = true;
      this.distanceGraphic.popupTemplate.content = content;
    }
  }

  private drawpolyline(event: any) {
    //console.log("event " + event.type);
    if (event.vertices && event.vertices.length > 0) {
      const curVertex = event.vertices.length-1; 
      
      // snap points to roads on click (not mouse movement)
      const vertexPt = new Point({
        x: event.vertices[curVertex][0],
        y: event.vertices[curVertex][1],
        spatialReference: this.view.spatialReference
      });

      //console.log("In DrawPolyline:  event.type ", event.type, " curVertex ", curVertex, " Vertex spatialRef " + this.view.spatialReference.wkid);
      if (event.type !== "cursor-update" && event.type !== "draw-complete") {
        if (curVertex === 0) {
          this.findRoute(vertexPt);
        } else if (curVertex === 1 && this.curRoute && this.curRoute.paths.length > 0) {
          this.addPoint(vertexPt, curVertex, event.type);
        }
      } else if (curVertex > 1 && this.curRoute && this.curRoute.paths.length > 0) { 
         this.addPoint(vertexPt, curVertex, event.type); 
      }

    }
  }
}
